import React, {Component} from 'react';
import {PropTypes} from "Subschema";
import CustomMaskedInput from "../card/CustomMaskedInput";


export default class MultiFormatInput extends Component {
    static propTypes = {
        "onChange": PropTypes.targetEvent,
        "formats": PropTypes.array,
        "placeHolderChar": PropTypes.string
    };

    static contextTypes = {
        maskedInoutUnsupported: React.PropTypes.bool
    }

    constructor (props, ...rest) {
        super(props, ...rest);
        this.formats = props.formats.slice(0); // making copy of formats for sorting
        this.formats.sort((a, b) => a.length - b.length);
        this.formatter = this.formats[0];
    }

    componentDidMount () {
        // Client side rendering allow multiple formats
        // adding an extra space to each format except for last one
        // *this is important for automatic format switching
        this.formats = this.formats.map((a, i) => {
            if (i < this.formats.length - 1) return a + '1';
            else return a;
        });

        // setting the default format to the shortest one
        this.formatter = this.formats[0];
    }

    componentWillReceiveProps (props) {
        if (props.value !== this.props.value) {
            // avoid null value dead loop
            this.handleFormatChange(props.value);
        }
    }

    handleFormatChange (value) {
        if (!value) return;

        var val = value.replace(/\D+/g, '');
        var i;

        for (i = 0; i < this.formats.length; i++) {
            if (val.length < this.formats[i].length) {
                break;
            }
        }
        this.formatter = i === this.formats.length ? this.formats[i-1] : this.formats[i];
    }

    render () {
        const {...props} = this.props;
        const placeHolderChar = this.props.placeHolderChar || " ";

        return (
            <CustomMaskedInput
                {...props}
                placeholderChar={placeHolderChar}
                mask={this.formatter}
            />
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/types/input/MultiFormatInput.jsx
 **/